import React, { useContext, useEffect, useState } from "react";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { SettingsContext } from "../../../../../contexts/Settings";
import { BASE_URL } from "../../../../../BaseUrl";
import {toast} from "react-toastify"; 
import { getCookie, _t, customStyle } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Select from "react-select";

const ChangePaymentType = ({
  changePaymentType,
  checkOrderDetails,
  setCheckOrderDetails,
}) => {
  const { t } = useTranslation();
  const { loading, setLoading,} = useContext(SettingsContext);
  const { paymentTypeForSearch } = useContext(RestaurantContext);
  const [paymentTypeAvailable, setPaymentTypeAvailable] =
    useState(paymentTypeForSearch);

  useEffect(() => {
    if (checkOrderDetails?.item?.associate_with_payment_type !== null) {
      let tempAvailablePaymentType = paymentTypeForSearch?.filter((item) => {
        return checkOrderDetails?.item?.associate_with_payment_type?.includes(
          item.id
        );
      });
      setPaymentTypeAvailable(tempAvailablePaymentType);
    }
  }, [checkOrderDetails.item]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = BASE_URL + "/settings/payment-type-transfer";
    const formData = {
      id: checkOrderDetails.item.id,
      branch_id: checkOrderDetails.item.branch_id,
      from_payment: checkOrderDetails.item.bill_distribution,
      to_payment: checkOrderDetails.payment_type[0]?.name,
    }

    setLoading(true);
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setLoading(false);
        setCheckOrderDetails({
          item: null,
          payment_amount: null,
          payment_type: null,
          settle: false,
          uploading: false,
          card_number: "",
        });
        changePaymentType.current.classList.remove("showing");
        toast.success(`${_t(t("Payment Type has been change successfully"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } catch (error) {
      setLoading(false);
      if(error?.response?.data && error.response.data?.status == 0){
        toast.error(`${_t(t(error.response.data.message))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  return (
    <div
      ref={changePaymentType}
      className="modal fade"
      id="changePaymentType"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div className="w-100 d-flex align-items-center justify-content-center">
              <div className="rider-text">Change Payment Type</div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  setCheckOrderDetails({
                    item: null,
                    payment_amount: null,
                    payment_type: null,
                    settle: false,
                    uploading: false,
                    card_number: "",
                  });
                  changePaymentType.current.classList.remove("showing");
                }}
              ></button>
            </div>
          </div>
          <div className="modal-body">
            {/* show form or show saving loading */}
            <div key="fragment-food-group-1">
              <form
                className="border my-2 rounded-lg"
                onSubmit={(e) => handleSubmit(e)}
                autoComplete="off"
              >
                <div className="mt-2 row">
                  <div className="col-6">
                    <div className="table-text ml-2 py-2">
                      {_t(t("Current Payment Type"))}
                    </div>

                    <div className="addons-list__item mx-2 mb-1">
                      {checkOrderDetails?.item
                        ? checkOrderDetails.item.bill_distribution
                        : "N/A"}
                    </div>
                  </div>
                  <div className="col-6">

                    <div className="table-text ml-2 py-2">
                      {_t(t("Change Payment Type"))}
                    </div>
                    <div className="addons-list__item mx-2 mb-1">
                      <Select
                        options={paymentTypeAvailable ? paymentTypeAvailable : []}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        position="fixed"
                        maxMenuHeight="15rem"
                        value={checkOrderDetails.payment_type ?? null}
                        onChange={(payment) => {
                          setCheckOrderDetails({
                            ...checkOrderDetails,
                            payment_type: [payment],
                          });
                        }}
                        className="table-text"
                        placeholder="Select payment type"
                        styles={customStyle}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center my-3 rounded">
                  <button
                    disabled={loading}
                    className="btn btn-sm btn-success text-center px-3 text-uppercase"
                    type="submit"
                  >
                    {_t(t("Submit"))}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePaymentType;
